/* ORILIS Landing theme — by EcomWhy */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function orderTarget() {
    return document.getElementById('order');
  }

  /* Buttons that point to #order scroll smoothly to the offer section. */
  function bindScrollLinks(root) {
    (root || document).querySelectorAll('a[href="#order"], [data-o-scroll]').forEach(function (el) {
      if (el.dataset.oBound) return;
      el.dataset.oBound = '1';
      el.addEventListener('click', function (e) {
        var t = orderTarget();
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        var first = t.querySelector('input:checked, input, button, a');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 500);
      });
    });
  }

  /* Ingredient slider: arrows + counter. */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-o-slider]').forEach(function (wrap) {
      if (wrap.dataset.oBound) return;
      wrap.dataset.oBound = '1';
      var track = wrap.querySelector('.o-slider');
      var cards = Array.prototype.slice.call(track.children);
      var prev = wrap.querySelector('[data-o-prev]');
      var next = wrap.querySelector('[data-o-next]');
      var counter = wrap.querySelector('[data-o-current]');
      var cur = 0;
      function sync() {
        var box = track.getBoundingClientRect();
        var mid = box.left + box.width / 2;
        var best = 0, dist = Infinity;
        cards.forEach(function (c, i) {
          var r = c.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - mid);
          if (d < dist) { dist = d; best = i; }
        });
        cur = best;
        if (counter) counter.textContent = best + 1;
        if (prev) prev.disabled = best === 0;
        if (next) next.disabled = best === cards.length - 1;
      }
      function go(i) {
        var n = Math.max(0, Math.min(cards.length - 1, i));
        var card = cards[n];
        var box = track.getBoundingClientRect();
        var r = card.getBoundingClientRect();
        var delta = (r.left + r.width / 2) - (box.left + box.width / 2);
        track.scrollBy({ left: delta, behavior: reduce ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; sync(); });
      }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* Screenshot reviews: "show more" reveals hidden cards. */
  function initMore(root) {
    (root || document).querySelectorAll('[data-o-more]').forEach(function (btn) {
      if (btn.dataset.oBound) return;
      btn.dataset.oBound = '1';
      btn.addEventListener('click', function () {
        var list = document.getElementById(btn.getAttribute('aria-controls'));
        if (!list) return;
        var hidden = list.querySelectorAll('[hidden]');
        var step = parseInt(btn.dataset.oMore, 10) || 4;
        for (var i = 0; i < hidden.length && i < step; i++) hidden[i].hidden = false;
        if (list.querySelectorAll('[hidden]').length === 0) btn.hidden = true;
      });
    });
  }

  /* Bundle choice updates the price shown on the submit button. */
  function initBundles(root) {
    (root || document).querySelectorAll('[data-o-bundles]').forEach(function (form) {
      if (form.dataset.oBound) return;
      form.dataset.oBound = '1';
      var label = form.querySelector('[data-o-total]');
      function update() {
        var sel = form.querySelector('input[name="quantity"]:checked');
        if (sel && label) label.textContent = sel.dataset.price || '';
      }
      form.addEventListener('change', update);
      update();
    });
  }

  /* Sticky order bar: shows once the visitor has scrolled past the offer, hides when it is back on screen. */
  function initSticky() {
    var bar = document.querySelector('[data-o-sticky]');
    if (!bar) return;
    var btn = bar.querySelector('a, button');
    function place() {
      var t = orderTarget();
      var on;
      if (t) {
        var r = t.getBoundingClientRect();
        on = r.bottom < 0;
      } else {
        on = window.scrollY > window.innerHeight;
      }
      if (on) bar.setAttribute('data-on', '');
      else bar.removeAttribute('data-on');
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }
    window.addEventListener('scroll', place, { passive: true });
    window.addEventListener('resize', place);
    place();
  }

  /* Mobile menu toggle. */
  function initMenu() {
    var toggle = document.querySelector('[data-o-menu]');
    var nav = document.getElementById('o-nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.hasAttribute('data-open');
      if (open) nav.removeAttribute('data-open'); else nav.setAttribute('data-open', '');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  function initAll(root) {
    bindScrollLinks(root);
    initSliders(root);
    initMore(root);
    initBundles(root);
  }

  ready(function () {
    initAll(document);
    initSticky();
    initMenu();
  });

  /* Re-init when sections change in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    initSticky();
  });
})();
